// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YVHo","option":"styles_option__1ux3s","active":"styles_active__3PfZH"};